<template>
    <div class="select-only position-relative mb-4 mx-auto" :class="[size === 'small' ? 'select-sm' : 'w-100']"
        @click.stop>
        <button @click.prevent="toggleDropdown" class="clasic2-select">
            <input type="text" v-model="searchQuery" @click="resetSearch" @keydown="handleKeydown"
                class="input-select font-A16 text-primary text-capitalize fw-bold"
                :readonly="!searchable || !dropdownOpen" @click.stop />
            <div class="position-absolute select-icon" :class="{ optionsOpen: dropdownOpen }"></div>
        </button>
        <div v-if="dropdownOpen" class="containerList select">
            <ul class="optionsList p-0 m-0">
                <li v-if="isLoading" class="option font-Pr text-muted" tabindex="-1">Buscando...</li>
                <template v-else>
                    <li v-for="(option, index) in filteredOptions" :key="index" @click="selectAndClose(option)"
                        class="option font-Pr text-capitalize" :class="{
                            selectedHighlight:
                                option === selectedOption ||
                                (typeof option === 'object' &&
                                    option[trackBy] === selectedOption?.[trackBy]),
                        }" tabindex="0">
                        {{ getOptionLabel(option) }}
                    </li>
                    <li v-if="filteredOptions.length === 0 && (!remote || searchQuery.length >= 2)"
                        class="option font-Pr" tabindex="0">
                        Sin resultados
                    </li>
                </template>
            </ul>
        </div>
    </div>
</template>

<script>
export default {
    props: ['size', 'trackBy', 'options', 'isResetting', 'isMercados', 'granos', 'isClima', 'value', 'searchable', 'remote'],
    /* Prop 'isMercados' se debe pasar como 'true' al utilizarse en Mercado Granos y Mercado Ganadero para cambiar la lógica de lo que sucede al seleccionar una opción. 'isClima también pero cuando se utiliza en Clima' */
    /* 'searchable' se debe pasar como true desde el componente padre, si se quiere funcionalidad para que sea buscable dentro del select. Esto sucede en PronosticoClimaComponent */
    /* 'remote' se debe pasar como true para activar la búsqueda server-side via /api/weather-locations */
    data() {
        return {
            selectedOption: null,
            searchQuery: '',
            dropdownOpen: false,
            remoteOptions: [],
            isLoading: false,
            debounceTimer: null,
        };
    },
    computed: {
        filteredOptions() {
            if (this.remote) {
                return this.remoteOptions;
            }
            if (this.searchable && this.searchQuery) {
                return this.options.filter((option) =>
                    this.getOptionLabel(option)
                        .toLowerCase()
                        .includes(this.searchQuery.toLowerCase())
                );
            } else {
                return this.options;
            }
        },
        displayText() {
            return this.selectedOption ? this.getOptionLabel(this.selectedOption) : '';
        },
    },
    created() {
        if (!this.remote && this.options && this.options.length > 0) {
            if(this.granos){
                this.selectedOption = this.options[2];
            }else{
                this.selectedOption = this.options[0];
            }
            this.searchQuery = this.getOptionLabel(this.selectedOption);
        } else if (this.value) {
            // When a value is already set (e.g. server-rendered default location),
            // seed searchQuery immediately — the watcher won't fire for initial prop values.
            this.selectedOption = this.value;
            this.searchQuery = this.getOptionLabel(this.value);
        }
    },
    methods: {
        getOptionLabel(option) {
            return typeof option === 'object' ? option[this.trackBy] : option;
        },
        selectOption(option) {
            this.selectedOption = option;
            this.searchQuery = this.getOptionLabel(option)
                console.log('option seleccionada:', option);
                console.log('id del tab a activar:', '#nav-' + option + '-tab-pane');
            if (this.isMercados) {
                /* Select utilizado en Mercado Granos y Mercado Ganadero */
                if (option === 'macho entero joven') {
                    $('.nav-tabs a[data-bs-target="#nav-mej-tab-pane"]').tab('show');
                }
                else {
                    $('.nav-tabs a[data-bs-target="#nav-' + option + '-tab-pane"]').tab('show');
                }

            }
            if (this.isClima) {
                /* Select utilizado en Pronóstico Clima */
                this.$emit('getClima', this.selectedOption.coordinates.lat, this.selectedOption.coordinates.lon);
            }
            this.$emit('update:selectedOption', option);
            this.$emit('isResetting', false);
        },
        resetSearch(event) {
            event.stopPropagation();
            this.searchQuery = '';
            this.dropdownOpen = true;
            if (this.remote) {
                this.remoteOptions = [];
            }
        },
        handleKeydown(event) {
            if (event.key === ' ') {
                event.stopPropagation();
                // Prevent the browser from firing a synthetic click on the parent <button>
                // when spacebar is pressed inside the input, which would close the dropdown.
                // Since preventDefault also blocks native character insertion, insert it manually.
                if (this.searchable && this.dropdownOpen) {
                    event.preventDefault();
                    const input = event.target;
                    const start = input.selectionStart ?? this.searchQuery.length;
                    const end   = input.selectionEnd   ?? this.searchQuery.length;
                    this.searchQuery = this.searchQuery.slice(0, start) + ' ' + this.searchQuery.slice(end);
                    this.$nextTick(() => input.setSelectionRange(start + 1, start + 1));
                }
            }
        },
        toggleDropdown(val) {
            if (val === false) {
                if (this.dropdownOpen) {
                    this.searchQuery = this.getOptionLabel(this.selectedOption);
                    this.dropdownOpen = false
                }
            } else {
                this.dropdownOpen = !this.dropdownOpen;
            }
        },
        selectAndClose(option) {
            const matchingOption = this.options
                ? this.options.find(
                    (originalOption) => this.getOptionLabel(originalOption) === this.getOptionLabel(option)
                  ) ?? option
                : option;
            this.selectedOption = matchingOption;
            this.dropdownOpen = false;
            this.selectOption(this.selectedOption);
        },
        async fetchRemote(query) {
            this.isLoading = true;
            try {
                const { data } = await axios.get('/api/weather-locations', {
                    params: { search: query }
                });
                this.remoteOptions = data;
            } catch (e) {
                this.remoteOptions = [];
            } finally {
                this.isLoading = false;
            }
        },
    },
    emits: [
        'getClima',
        'update:selectedOption',
        'update:isResetting',
        'isResetting',
    ],
    watch: {
        searchQuery(val) {
            if (!this.remote) return;
            clearTimeout(this.debounceTimer);
            if (!val || val.length < 2) {
                this.remoteOptions = [];
                return;
            }
            this.debounceTimer = setTimeout(() => this.fetchRemote(val), 300);
        },
        isResetting(newValue) {
            if (newValue) {
                this.selectedOption = this.options[0];
                this.$emit('update:isResetting', false);
            }
        },
        value(newValue) {
            if (newValue) {
                if (this.isClima) {
                    this.selectedOption = newValue;
                    this.searchQuery = this.getOptionLabel(newValue);
                }
            }
        },
    },
};
</script>